// The /app shell renders under CSS `zoom` (see index.css). Rects and pointer
// coordinates come back in zoomed viewport pixels while CSS lengths apply
// before the zoom, so positioning and hit-testing math converts with these.
export function cssZoom() {
  if (typeof document === 'undefined' || !document.body) return 1;
  const own = document.body.currentCSSZoom;
  if (Number.isFinite(own) && own > 0) return own;
  const root = parseFloat(window.getComputedStyle(document.documentElement).zoom);
  return Number.isFinite(root) && root > 0 ? root : 1;
}

// An element's bounding rect in unzoomed CSS pixels.
export function localRect(el) {
  const r = el.getBoundingClientRect();
  const z = cssZoom();
  return {
    left: r.left / z, right: r.right / z, top: r.top / z, bottom: r.bottom / z,
    width: r.width / z, height: r.height / z,
  };
}

// The viewport size in unzoomed CSS pixels.
export function localViewport() {
  const z = cssZoom();
  return { width: window.innerWidth / z, height: window.innerHeight / z };
}
